import React from "react";
import "./TextBorder.css";

export default function TextBorder({ children }) {
  return <div className="text-border">{children}</div>;
}
